import { Button, Drawer, Flex, Text, Textarea } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { drawerTransitionProps } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling.tsx';

interface Props {
	opened: boolean;
	onClose: () => void;
	initialAnnotation?: string | null;
	isSubmitting?: boolean;
	onConfirm: (annotation: string) => void;
}

export const IncompletePaymentDrawer = ({
	opened,
	onClose,
	initialAnnotation,
	isSubmitting = false,
	onConfirm,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const [message, setMessage] = useState('');

	useEffect(() => {
		if (opened) {
			setMessage(initialAnnotation ?? '');
		}
	}, [opened, initialAnnotation]);

	return (
		<Drawer
			opened={opened}
			onClose={onClose}
			position="right"
			title={tMipManage('payments.drawer.title')}
			transitionProps={drawerTransitionProps}
			trapFocus={false}
		>
			<Flex direction="column" justify="space-between" h="100%" gap="md">
				<Flex direction="column" gap="md">
					<Text size="sm" c="dark.1">
						{tMipManage('payments.drawer.subtitle')}
					</Text>
					<Textarea
						label={tMipManage('payments.drawer.instructions_label')}
						placeholder={tMipManage('payments.drawer.instructions_placeholder')}
						minRows={4}
						value={message}
						onChange={(event) => setMessage(event.currentTarget.value)}
					/>
				</Flex>
				<Flex direction="column" gap="xs">
					<Button fullWidth loading={isSubmitting} onClick={() => onConfirm(message)}>
						{tMipManage('payments.drawer.confirm_rejection')}
					</Button>
					<Button variant="subtle" fullWidth onClick={onClose}>
						{tMipManage('payments.drawer.cancel_status_change')}
					</Button>
				</Flex>
			</Flex>
		</Drawer>
	);
};
